'use client';

import React__default, { useState, useEffect } from 'react';

var easeOutQuad = function (t) {
    return t * (2 - t); // Ease-out function
};
var CountUp = function (_a) {
    var start = _a.start, end = _a.end, duration = _a.duration;
    var _b = useState(start), count = _b[0], setCount = _b[1];
    useEffect(function () {
        var startTime = performance.now();
        var tick = function () {
            var currentTime = performance.now();
            var elapsed = currentTime - startTime;
            // Calculate the progress (0 to 1)
            var progress = Math.min(elapsed / duration, 1); // Clamp between 0 and 1
            var easedProgress = easeOutQuad(progress); // Apply easing
            // Calculate the current count based on eased progress
            var newCount = Math.round(easedProgress * end);
            setCount(newCount);
            if (progress < 1) {
                requestAnimationFrame(tick);
            }
        };
        requestAnimationFrame(tick);
    }, [end, duration]);
    return React__default.createElement(React__default.Fragment, null, Math.round(count));
};

export { CountUp as default };
//# sourceMappingURL=index.js.map
